// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3t3RD","label":"Category_label__1MRmw","content":"Category_content__1PvoL","header":"Category_header__2RPKO","location":"Category_location__AKY7W"};